/**
 * Created by Languagenut on 17/09/2019.
 */


import React  from 'react';
import TotalsBlock from '../charts/totals_block.js';
import Radar from '../charts/skills_radar.js';
import LearntLine from '../charts/learnt_line.js';
import Bar from '../charts/learnt_bar.js';
import Translation from  '../../store/internationalization-store.js';
import {Badge , Media , Navbar , Form , Button , Card , Row , Col , Nav , NavDropdown} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';

export default class Achviements extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            data: this.props.data
        }
    }

    render(){

        return  <Card body>
            <h6>Top Awarded Achivements</h6>
            <Row>
                <Col md={6}>
                    <Card body>
                        <Media>
                            <img
                                height={64}
                                className="mr-3"
                                src="./img/achviements_icons/Asset 1.png"
                                alt="Generic placeholder"
                                />
                            <Media.Body>
                                <h5>Speed Demon</h5>
                                <p>
                                    User Completed Matching Paires in uner 30 seconds
                                </p>
                            </Media.Body>
                        </Media>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card body>
                        <Media>
                            <img
                                height={64}
                                className="mr-3"
                                src="./img/achviements_icons/Asset 49.png"
                                alt="Generic placeholder"
                                />
                            <Media.Body>
                                <h5>Speed Demon</h5>
                                <p>
                                    User Completed Matching Paires in uner 30 seconds
                                </p>
                            </Media.Body>
                        </Media>
                    </Card>
                </Col>
            </Row>
            <br/>
            <h6>Achivements</h6>
            <Row>
                <Col md={3}><Card body><center><img  height={64}  src="./img/achviements_icons/Asset 1.png" alt="Generic placeholder"/><p>Speed Demon</p></center></Card></Col>
                <Col md={3}><Card body><center><img  height={64}  src="./img/achviements_icons/Asset 49.png" alt="Generic placeholder"/><p>Speed Demon</p></center></Card></Col>
                <Col md={3}><Card body><center><img  height={64}  src="./img/achviements_icons/Learning-Homework.png" alt="Generic placeholder"/><p>Speed Demon</p></center></Card></Col>
                <Col md={3}><Card body><center><img  height={64}  src="./img/achviements_icons/Ranking-01.png" alt="Generic placeholder"/><p>Speed Demon</p></center></Card></Col>
            </Row>
        </Card>

    }
}